import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { ScaledTextButton } from '../../../../components/scaledTextButton';
import { setIsSelectingSideBetTarget } from '../../../../redux/actions/sideBetsActions';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { getCurrencyAmountString } from '../../../../utils/currencyUtils';
export const DomSideBetButton = ({ bounds }) => {
    const sideBetCost = useAppSelector((state) => state.poker.sideBetCost);
    const isSelectingSideBetTarget = useAppSelector((state) => state.sideBets.selectSideBetTargetStartTimestampMs !== undefined);
    const dispatch = useAppDispatch();
    const onClickSideBet = useCallback(() => {
        dispatch(setIsSelectingSideBetTarget(!isSelectingSideBetTarget));
    }, [dispatch, isSelectingSideBetTarget]);
    if (sideBetCost === undefined) {
        return null;
    }
    const { x, y, w, h } = bounds;
    return (_jsx(ScaledTextButton, { onClick: onClickSideBet, label: isSelectingSideBetTarget ? 'CANCEL' : 'SIDE BET', subLabel: isSelectingSideBetTarget ? 'SIDE BET' : getCurrencyAmountString(sideBetCost, 'jacks').toUpperCase(), x: x, y: y, w: w, h: h, theme: 'side-bet', testId: isSelectingSideBetTarget ? 'cancel-side-bet' : 'side-bet' }));
};
